//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KirbyLink from './kirbylink.vue'
export default {
    name: "frmterms",
    props:{
      content: Object
    },
    components:{
      KirbyLink
    }
}
